var InfoLauncher = function() {
    this.launch = function() {
        window.open(CudaLaunch.serverConfiguration.infoFileName, "_blank");
    };
};

module.exports = InfoLauncher;




//////////////////
// WEBPACK FOOTER
// ./info/InfoLauncher.js
// module id = 66
// module chunks = 0